export enum ContactTypes{
    EMAIL = 1,
    PHONE = 3,
    FACEBOOK = 5,
    INSTAGRAM = 6,
    LINKEDIN = 7,
    WWWADDRESS = 8,
}